<template>
    <div>

        <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>

        <!-- 1. Sticky title bar -->
        <div class="fs-title-bar">
            <h2 class="pb-2">{{ this.parentObject.pageTitle }}<span class="page_title_value pl-2">{{ this.parentObject.pageTitleValue }}</span></h2>
        </div>

        <v-container style="max-width:100%;overflow-x:hidden;padding-left:24px;padding-right:24px;">
            <v-form ref="form">

                <v-container
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5"
                >

                    <div>
                        <v-row>
                            <v-col cols="3" sm="3" class="pb-n5">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercise.exercisecode')"
                                    ref="kpiexercode"
                                    readonly
                                    v-model="formData.kpiexercode"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="8" sm="8" class="pb-n5">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercise.exercisedesc')"
                                    ref="kpiexerdesc"
                                    readonly
                                    v-model="formData.kpiexerdesc"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.periodstartdate')"
                                    ref="startdate"
                                    type="date"
                                    readonly
                                    v-model="formData.startdate"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.periodenddate')"
                                    ref="enddate"
                                    type="date"
                                    readonly
                                    v-model="formData.enddate"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.status')"
                                    ref="kpiexerstatus"
                                    type="text"
                                    readonly
                                    v-model="formData.kpiexerstatus"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <!-- 3. Stat cards — same style as Review Exercise -->
                        <v-row class="mb-1 mt-2">
                            <v-col cols="12">
                                <span class="review-stats-label">{{$t('appraisalexerciserecords.reviewstatistics')}}</span>
                            </v-col>
                        </v-row>
                        <v-row class="mb-4" align="stretch">
                            <v-col cols="4" sm="4">
                                <div class="review-stat-card review-stat-initiated">
                                    <div class="review-stat-label">{{$t('columns.locked')}}</div>
                                    <div class="review-stat-value">{{ formData.locked || 0 }}</div>
                                </div>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <div class="review-stat-card review-stat-ongoing">
                                    <div class="review-stat-label">{{$t('columns.pending')}}</div>
                                    <div class="review-stat-value">{{ formData.pending || 0 }}</div>
                                </div>
                            </v-col>
                            <v-col cols="4" sm="4">
                                <div class="review-stat-card review-stat-completed">
                                    <div class="review-stat-label">{{$t('columns.open')}}</div>
                                    <div class="review-stat-value">{{ formData.open || 0 }}</div>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>

                <!-- 2. Full-width grid table -->
                <v-container style="max-width:100%;padding-left:0;padding-right:0;">
                    <div>
                        <v-row>
                            <v-col cols="12" class="pa-0">
                            <app-table
                                v-bind:parentObject = "{
                                    tabHeader: this.tabHeader,
                                    detailItem: this.staffList,
                                    formData: this.formData,
                                    pageTitle: this.parentObject.pageTitle,
                                    pageTitleValue: this.parentObject.pageTitleValue,
                                }"
                            />
                            </v-col>
                        </v-row>
                    </div>
                </v-container>

                <v-row>
                    <div class="pt-5 pl-7">
                        <v-row>
                        <v-col>
                        <v-btn 
                            color="warning" 
                            style="width: 100px; margin-bottom: 20px;"
                            @click="closeHandler" 
                            > 
                            {{$t('button.close')}}
                        </v-btn>
                        </v-col>
                        </v-row>
                    </div>
                </v-row>

            </v-form>
        </v-container>
    </div>
</template>

<script>
import CRUDTable from './CRUDTableStaff';

export default {
    props: {
        parentObject: Object
    },

    components: {
       'app-table': CRUDTable,
    },


    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || this.$t('periodicincentivesetup.invalidemail');
                }
            },

            formData: this.parentObject.data,
            staffList: this.parentObject.staffList,
            
            tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '100px', sortable: false},
                { text: this.$t('columns.staffcode'), value: 'staffcode', width: '200px', sortable: true},
                { text: this.$t('columns.name'), value: 'staffname', width: '200px', sortable: true},
                { text: this.$t('appraisalrecord.reviewer'), value: 'reviewercode', width: '200px', sortable: true},
                { text: this.$t('appraisalrecord.reviewername'), value: 'reviewername', width: '200px', sortable: true},
                { text: this.$t('columns.periodstartdate'), value: 'periodstartdate', width: '200px', sortable: true},
                { text: this.$t('columns.periodenddate'), value: 'periodenddate', width: '200px', sortable: true},
                // { text: 'Status', value: 'status', width: '200px', sortable: true},
                { text: this.$t('columns.company'), value: 'compnycode', width: '200px', sortable: true},
                { text: this.$t('columns.branch'), value: 'brchcode', width: '200px', sortable: true},
                { text: this.$t('columns.department'), value: 'deptcode', width: '200px', sortable: true},
                { text: this.$t('columns.section'), value: 'sectiocode', width: '200px', sortable: true},
                { text: this.$t('columns.unit'), value: 'unitcode', width: '200px', sortable: true},
                { text: this.$t('columns.grade'), value: 'grdcode', width: '200px', sortable: true},
                { text: this.$t('columns.position'), value: 'poscode', width: '200px', sortable: true},
                { text: this.$t('performancemanagement.createddate'), value: 'createdate', width: '200px', sortable: true},
                { text: this.$t('performancemanagement.completeddate'), value: 'completedate', width: '200px', sortable: true},
            ],

            errMsg: "",
            isErr: false,
        }
    },

    methods: {
        closeHandler(){
            this.$router.push({name: 'kpisettinglist'});
        },
    },
}
</script>

<style scoped>
.fs-title-bar {
    position: sticky;
    top: 0;
    z-index: 20;
    background: #ffffff;
    padding: 16px 24px 0 24px;
}
</style>